import { createActions } from 'redux-actions';
var prefix = 'APP';
var actionTypes = ['TOGGLE_DRAWER', 'SET_ONLINE', 'SET_OFFLINE', 'TOGGLE_SEARCH', 'EXECUTE_SEARCH', 'MARK_ERROR_HANDLED', 'SET_PAGE_LOADING', 'SET_IP_LAT_LNG', 'SET_OPEN_STORE_MODAL', 'SET_STORE_MODAL_SINGLE_PRODUCT_ID', 'SET_CURRENT_STORE', 'SET_OPEN_SEARCH_BAR', 'SET_SEARCH_BAR_VALUE', 'SET_PRODUCT_BADGES', 'SET_STORE_CONFIG', 'SET_CATEGORY_DATA', 'SET_PREFERENCE_COOKIES', 'SET_GTM_SCRIPT_LOADED'];
export default createActions(...actionTypes, {
  prefix
});